<template>
  <v-row>
    <v-col cols="12" v-text="$route.name" class="grey--text text-h2" />
    <v-col cols="12">
      <form-filtros :loading="loading" @buscar="onClickBuscar($event)" />
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-tabs v-model="tab" grow @change="onChangeTab">
          <v-tab key="efetuadas" href="#efetuadas">Inscrições Efetuadas</v-tab>
          <v-tab key="deferidas" href="#deferidas"
            >Inscrições Deferidas para minha unidade</v-tab
          >
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item value="efetuadas" key="efetuadas">
            <tabela-efetuadas
              v-if="inscricoes"
              :inscricoes="inscricoes"
              :loading="loading"
              @save="onUpdateInscricao($event)"
            />
          </v-tab-item>
          <v-tab-item value="deferidas" key="deferidas">
            <tabela-deferidas
              v-if="inscricoes"
              :inscricoes="inscricoes"
              :loading="loading"
              @save="onUpdateInscricao($event)"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import FormFiltros from "./components/FormFiltros";
import TabelaDeferidas from "./components/TabelaDeferidas";
import TabelaEfetuadas from "./components/TabelaEfetuadas";
import { getUser, getAtribuicaoAtiva } from "@/plugins/security";

export default {
  name: "consulta-plantao-unidades",

  components: {
    FormFiltros,
    TabelaDeferidas,
    TabelaEfetuadas,
  },

  data: () => ({
    user: getUser(),
    inscricoes: null,
    loading: false,
    tab: "efetuadas",
  }),

  mounted() {
    this.getInscricoesEfetuadas();
  },

  methods: {
    onChangeTab(tab) {
      tab === "efetuadas"
        ? this.getInscricoesEfetuadas()
        : this.getInscricoesDeferidas();
    },

    onClickBuscar(filtros) {
      this.tab === "efetuadas"
        ? this.getInscricoesEfetuadas(filtros)
        : this.getInscricoesDeferidas(filtros);
    },

    getInscricoesEfetuadas(filtros) {
      this.loading = true;
      this.inscricoes = [];
      const atribuicaoID = getAtribuicaoAtiva().id;

      this.$http
        .get("/plantao-ferias-efetuados-unidade", { params: { atribuicaoID } })
        .then((inscricoes) => {
          // Ordena alfabeticamente
          let lista = inscricoes.sort((a, b) => {
            const nameA = a.matricula.pessoa.nome.toUpperCase();
            const nameB = b.matricula.pessoa.nome.toUpperCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          });

          this.inscricoes = this.filtrarInscricoes(lista, filtros);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.showMessage(error, "error");
        });
    },

    getInscricoesDeferidas(filtros) {
      this.loading = true;
      this.inscricoes = [];
      const atribuicaoID = getAtribuicaoAtiva().id;

      this.$http
        .get("/plantao-ferias-deferidos-unidade", { params: { atribuicaoID } })
        .then((inscricoes) => {
          // Ordena alfabeticamente
          let lista = inscricoes.sort((a, b) => {
            const nameA = a.matricula.pessoa.nome.toUpperCase();
            const nameB = b.matricula.pessoa.nome.toUpperCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          });

          this.inscricoes = this.filtrarInscricoes(lista, filtros);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.showMessage(error, "error");
        });
    },

    filtrarInscricoes(lista, filtros) {
      if (!filtros) return lista;

      let resultado = lista;

      if (filtros.protocolo && filtros.protocolo.trim() !== "") {
        resultado = resultado.filter((item) =>
          String(item.protocolo)
            .toLowerCase()
            .includes(filtros.protocolo.toLowerCase().trim())
        );
      }

      if (filtros.nome && filtros.nome.trim() !== "") {
        resultado = resultado.filter((item) =>
          item.matricula.pessoa.nome
            .toLowerCase()
            .includes(filtros.nome.toLowerCase().trim())
        );
      }

      if (filtros.status && filtros.status.trim() !== "") {
        resultado = resultado.filter((item) =>
          String(item.status)
            .toLowerCase()
            .includes(filtros.status.toLowerCase().trim())
        );
      }

      return resultado;
    },

    onUpdateInscricao(inscricao) {
      const index = this.inscricoes.findIndex((i) => i.id === inscricao.id);

      Object.assign(this.inscricoes[index], inscricao);
    },
  },
};
</script>
